import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Chip from '@material-ui/core/Chip';
import Grid from "@material-ui/core/Grid";
import clsx from "clsx";
import translate from '../../other/translate.json';

export default function AppTagChipArrayTop(props) {
	const { variant } = props
	const classes = useStyles();
	const [chipData, setChipData] = React.useState([]);
	let lang = localStorage.getItem('language') || 'Ru'

	function buildChip() {
		let arr = [];
		if (props.isResearchMarket && props.isResearchMarket.length > 2) {
			arr.push({ key: 1, label: translate.Words[`DemandUnderResearch${lang}`], bgcolor: '#BCBBD0' })
		}
		
		if (props.isStandant && props.isStandant.length > 2) {
			arr.push({ key: 2, label: translate.Words[`StandardPackage${lang}`], bgcolor: '#81D39D' })
		}

		if (props.dataEndSale && props.dataEndSale.length > 2) {
			arr.push({ key: 3, label: translate.Words[`Archive${lang}`], bgcolor: '#BCBBD0' })
		}

		if (props.dataStartSale) {
			arr.push({ key: 4, label: props.dataStartSale, bgcolor: '#FE9D67' })
		}

		if (props.isCloudApp === 1) {
			arr.push({ key: 5, label: translate.Words[`CloudApp_${lang}`], bgcolor: '#67C8FE' })
		}
		if (props.isNew === 1) {
			arr.push({ key: 7, label: translate.Words[`New${lang}`], bgcolor: '#81D39D' })
		}
		// if (moment(props.DateStartStock) < new Date() && moment(props.DateEndSaleStock) > new Date() && props.StockLink && props.StockLink.length > 5) {
		// 	arr.push({ key: 5, label: translate.Words[`Promo${lang}`], bgcolor: '#8094FF' })
		// }
		if (props.text) {
			let color = '#81D39D'
			let text = props.text
			switch (props.text) {
				case 'Развитие': color = '#8094FF'; break;
				case 'Анонс': color = '#FE9D67'; break;
				case 'Новое': text = 'Новинка'; color = '#81d39d'; break;
				default: text = ''; break;
			}
			arr.push({ key: 6, label: transliteText(text), bgcolor: color })
		}

		setChipData(arr)
	}

	function buildChip1() {
		let arr = [];
		if (props.isResearchMarket && props.isResearchMarket.length > 2) {
			arr.push({ key: 1, label: translate.Words[`DemandUnderResearch${lang}`], bgcolor: '#8094FF' })
		}

		if (props.isStandant && props.isStandant.length > 2) {
			arr.push({ key: 2, label: props.isStandant, bgcolor: '#81D39D' })
		}

		if (props.dataEndSale && props.dataEndSale.length > 2) {
			arr.push({ key: 3, label: translate.Words[`Archive${lang}`], bgcolor: '#BCBBD0' })
		}

		if (props.announcement) {
			arr.push({ key: 4, label: props.announcement, bgcolor: '#FE9D67' })
		}

		if (props.promo) {
			arr.push({ key: 4, label: props.promo, bgcolor: '#DF6291' })
		}

		if (props.isModernSystems === 1) {
			arr.push({ key: 5, label: translate.Words[`ModernSystems_${lang}`], bgcolor: '#7D62BA' })
		}

		if (props.isCloudApp === 1) {
			arr.push({ key: 5, label: translate.Words[`CloudApp_${lang}`], bgcolor: '#67C8FE' })
		}
		if (props.isNew === 1) {
			arr.push({ key: 7, label: translate.Words[`New${lang}`], bgcolor: '#81D39D' })
		}

		// if (moment(props.DateStartStock) < new Date() && moment(props.DateEndSaleStock) > new Date() && props.StockLink && props.StockLink.length > 5) {
		// 	arr.push({ key: 5, label: translate.Words[`Promo${lang}`], bgcolor: '#8094FF' })
		// }
		if (props.text) {
			let color = '#81D39D'
			let text = props.text
			switch (props.text) {
				case 'Развитие': color = '#8094FF'; break;
				case 'Анонс': color = '#FE9D67'; break;
				case 'Новое': text = 'Новинка'; color = '#81d39d'; break;
				default: text = ''; break;
			}
			arr.push({ key: 6, label: transliteText(text), bgcolor: color })
		}

		setChipData(arr)
	}

	const transliteText = (text) => {
		switch (text) {
			case 'Анонс': return (translate.Words[`ComingSoon${lang}`]);
			case 'Новое': return (translate.Words[`New${lang}`]);
			case 'Развитие': return (translate.Words[`Development${lang}`]);
			default: return text;
		}
	}

	useEffect(() => {
		variant === 1 ? buildChip1() : buildChip()
	}, [props.announcement])

	return (
		<Grid
			item
			lg={12} md={12} sm={12}
			component="ul"
			className={clsx(classes.root, {
				[classes.topCardTagArray]: props.position === 'topCard',
				[classes.topTagArray]: props.position === 'top',
				[classes.middleTagArray]: props.position === 'middle',
				[classes.bottomTagArray]: props.position === 'bottom',
			})}
			style={{ maxWidth: props.width ? props.width : '' }}
		>
			{chipData.length > 0 ? chipData.map((data) => {
				// console.log('data.label,data.label',data.label)
				return (
					<li key={`${data.key}__topChipData`} className={classes.li} onClick={() => console.log('')}>
						{props.event && (data.label == "Promo" || data.label == "Акция")
							?
							<a href={`${props.event}`} target="blank" style={{ textDecoration: 'none', cursor: 'pointer' }}>
								<Chip
									style={{ backgroundColor: data.bgcolor, cursor: 'pointer' }}
									label={transliteText(data.label)}
									className={classes.chip}
								/>
							</a>
							:
							<Chip
								style={{ backgroundColor: data.bgcolor }}
								label={transliteText(data.label)}
								className={classes.chip}
							/>
						}
					</li>
				);
			}) : ''}
		</Grid>
	);
}


const useStyles = makeStyles((theme) => ({
	root: {
		display: 'flex',
		// justifyContent: 'center',
		flexWrap: 'wrap',
		listStyle: 'none',
		color: '#F00',
		justifyContent: 'start',
		padding: '0 12px'
	},

	chip: {
		height: 24,
		margin: 0,
		padding: theme.spacing(0, 1),
		backgroundColor: '#BCBBD0',
		fontSize: 13,
		lineHeight: '16px',
		color: '#FFF',
		borderRadius: 39,
		boxShadow: '4px 4px 16px rgba(68, 113, 209, 0.04)',
		fontWeight: 400,
		'& > span': {
			padding: 0
		},
	},

	li: {
		margin: '0 3.5px',

		'&:first-child': {
			marginLeft: 0
		},

		'&:last-child': {
			marginRight: 0
		},
	},

	topTagArray: {
		padding: '0 0 8px 0 !important',
		justifyContent: 'flex-end',
	},

	topCardTagArray: {
		padding: '0 !important',
		justifyContent: 'flex-end',
	},

	middleTagArray: {
		padding: '0 12px !important',
	},

	bottomTagArray: {
		padding: '0 12px !important',
	}
}));